module.exports = __webpack_public_path__ + "static/media/difficulty2.bbd1b16f.png";